module.exports = __webpack_public_path__ + "img/xendit.5e691344.png";